import React, { Component } from "react";
import Charts from "./components/Charts";

import "./App.css";

class App extends Component {
  render() {
    return (
      <div className="container">
        <Charts />
      </div>
    );
  }
}

export default App;
